import styled from 'styled-components';

export const TopCausesSection = styled.section`
    .row {
        align-items: center;
    }
    
    .search-header{
        display:none;
    }

    &.page-main-title{
        max-width: 500px;
    }
    
    p {
        padding-bottom: 25px;
        &:last-child{
            padding-bottom: 0px;
        }
    }
`;

export const TopCausesListSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding: 50px 0px;

    .row{
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        gap: 20px 0px;
        justify-content: flex-start;
    }

    .col{
        display: flex;
        flex-direction: column;
        row-gap: 20px;
    }

    span{
        font-size: 16px;
    }
    .top-causes-count{
        column-count: 3;
        counter-reset: item-counter;

        @media screen and (max-width: 991px){
            column-count: 2;
        }
        @media screen and (max-width: 575px){
            column-count: 1;
        }
    }
.loader-cities{
        .loading {
          top:64%;
        }
    }
`;

export const CausesListBox = styled.div`
    width: 100%;
    max-width: 384px;
    margin-bottom: 20px;
    break-inside: avoid;

    @media screen and (max-width: 767px){
       max-width: inherit;
    }

    @media screen and (max-width: 991px){
        margin-bottom: 15px;
    }

    &:last-child{
        margin-bottom: 0px;
        @media screen and (max-width: 767px){
            margin-bottom: 15px;
        }
    }

    button{
        display: none;
    }
    h3{
        font-size: 18px;
        line-height: 26px;

        @media screen and (max-width: 991px){
            font-size: 16px;
            line-height: 24px;
        }
    }
    span{
        font-size: 18px;
        line-height: 26px;
    }
`;

export const TopCausesImageBox = styled.div`
    width: 100%;
    background: #FFFFFF;
    border-radius: 20px;
    padding: 10px;
    box-shadow: 0px 10px 30px #00000014;
    margin-bottom: 20px;

    @media screen and (max-width: 767px){
        border-radius: 15px;
    }

    &:last-child{
        margin-bottom: 0px;
    }

    img{
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 15px;
        
        @media screen and (max-width: 767px){
            border-radius: 10px;
        }
    }  
`;

export const TopCausesListBox = styled.div`
    width: 100%;
    margin-bottom: 20px;
    break-inside: avoid;
    
    &:last-child{
        margin-bottom: 0px;
    }
    .top-cause-btn-show{
        display: block;
    }
`;

export const TopCausesBannerWrap = styled.div`
    
    @media screen and (max-width: 1024px){ 
        padding-top: 128px;
    }
    @media screen and (max-width: 767px){ 
        padding-top: 114px;
    }

    .base-text{
        padding-bottom:0px;
    }

    &.search-header{
        display: none;
    }

    .page-main-heading{
        max-width: 100%; 
    }
    button{
        color: #01606F;
        font-size: 18px;
        font-family: "Jost", sans-serif;
        font-weight: 700;
        line-height: 22px;
        cursor: pointer;
        background: transparent;
        border: none;
        padding: 0;
        vertical-align: baseline !important;

        &:hover{
            background: transparent;
            border: none;
            color: #01606F;
        }
        &:active{
            background: transparent !important;
            border: none !important;
            color: #01606F !important;
        }
    }

    .top-causes-banner{
        @media screen and (max-width: 1024px){ 
            padding: 60px 0px 50px;
        }

        @media screen and (max-width: 767px){ 
            padding-top: 80px;
        }
        .left_banner{
            
            @media screen and (max-width: 1024px){ 
                margin-bottom: 0;
            }
        }
    }
`;